import _ from 'lodash';

export function onInputDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: onInputDirectiveCtrl,
	};
}

export class onInputDirectiveCtrl {
	constructor($scope, $element, $attrs, $timeout) {
		'ngInject';
		const throttleMs = parseFloat($attrs.shOnInputThrottle);
		const debounceMs = parseFloat($attrs.shOnInputDebounce);
		let oldValue = $element[0].value;
		let handler = evt => {
			const newValue = $element[0].value;
			$timeout(() => {
				$scope.$eval($attrs.shOnInput, {
					$event: evt,
					$oldValue: oldValue,
					$newValue: newValue,
				});
				oldValue = newValue;
			});
		};
		if (debounceMs > 0) {
			handler = _.throttle(handler, debounceMs, { leading: false, trailing: true });
		}
		if (throttleMs > 0) {
			handler = _.throttle(handler, throttleMs, { leading: true, trailing: true });
		}
		$element.on('input', handler);
	}
}
